import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const OscillatingDiskRheometer = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F9.png?alt=media&token=dde547ae-ac56-4f01-94e7-b47fd80456cb',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F9.png?alt=media&token=dde547ae-ac56-4f01-94e7-b47fd80456cb'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/rubber-polymer-industries">Rubber & Polymer Industries</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Oscillating Disk Rheometer </h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Oscillating Disk Rheometer </h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    The Vluchem’ s ODR -10, Oscillating Disk Rheometer is a reliable, accurate and easy to
                                    operate Rheometer suit for routine and standards testing of rubber curing. The ODR-10 uses
                                    biconical disk [rotor] meeting all relevant ASTM and ISO standards. The Vluchem’ s ODR-10
                                    is excellent to operate the stage for QC and R&amp;D circumstances.
                                    Standards the instrument complies with ASTM D 2084, ISO 3417
                                    <br /> <br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Oscillating Disk Rheometer"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
        </Layout>
    )
}

export default OscillatingDiskRheometer